<header *ngIf="title || card.config.subtitle" class="bl-margin-bottom--24">
  <div class="bl-display--flex">
    <h2
      *ngIf="title"
      class="bl-font-weight--900 bl-flex--auto bl-font-color--black bl-font-size--28 bl-margin-bottom--0"
      [class.bl-required]="card.config.required"
      [attr.id]="'title-' + card.id"
    >
      {{ title }}
    </h2>
    <button
      *ngIf="card.showRemove"
      id="remove-{{ card.id }}"
      (click)="card.remove()"
      class="bl-button bl-button-tertiary bl-button-small"
      [attr.aria-labelledby]="'remove-' + card.id + ' ' + 'title-' + card.id"
    >
      <span class="bl-display--flex bl-align-items--center bl-justify-content--center">
        <i class="cu-trash-can bl-margin-right--4"></i>Remove
      </span>
    </button>
  </div>
  <p *ngIf="card.config.subtitle" class="bl-font-color--steel bl-font-color--black bl-font-size--14 bl-margin-bottom--0 bl-margin-top--8">
    <span class="bmp-overflow-wrap--break-word" [innerHTML]="card.config.subtitle | safe : 'html'"> </span>
  </p>
</header>
